<template>
  <div class="personnelSelectionPanel" v-loading="loading">
    <div class="top">
      <div class="title">成员多选</div>
      <i @click="close" class="iconfont icon-close" />
    </div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-change="handleChange" class="personnelSelectionPanelTabs">
        <el-tab-pane label="组织架构" name="organizational">
          <Organizational
            ref="organizationalRef"
            :key="refreshKey"
            :data="componentData.deComponentTreeVO"
            :userResignList="componentData?.userResignVOList"
            :orginComponentData="orginComponentData.deComponentTreeVO"
            :disabledIds="disabledIds"
            :checkedUser="checkedUser"
            :isWorkbench="$attrs.isWorkbench"
            :oldCheckUserIds="showValueData"
            @updateValue="updateValue"
          />
        </el-tab-pane>
        <el-tab-pane label="角色" name="role" v-if="isRoleVisible">
          <Role
            ref="roleRef"
            :key="refreshKey"
            v-model:data="componentData.roleVOList"
            :userResignList="componentData?.userResignVOList"
            :checkedUser="checkedUser"
            @updateValue="updateValue"
          />
        </el-tab-pane>
        <el-tab-pane label="成员" name="members">
          <Members
            ref="membersRef"
            :key="refreshKey"
            v-model:data="componentData.userVOList"
            :checkedUser="checkedUser"
            :disabledIds="disabledIds"
            :oldCheckUserIds="showValueData"
            @updateValue="updateValue"
          />
        </el-tab-pane>
        <el-tab-pane v-if="configuration" label="动态参数" name="dynamicParameters">
          <slot name="dynamic">
            <DynamicParametersVue :data="dynamicParameters" @updateParameter="updateParameter" />
          </slot>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottom">
      <div class="left" v-if="isRoleVisible">
        <el-checkbox
          v-model="isShowResigned"
          :label="`显示离职员工（${componentData?.userResignVOList?.length || 0}人）`"
        />

        <div v-if="activeName === 'organizational'">
          <el-checkbox v-model="saveDefult" v-if="showDefault" label="保存默认值" />
          <el-checkbox v-model="allChecked" label="选中所有可见选项" />
          <el-checkbox v-model="isIncludeChild" label="父部门不包含子部门员工" />
        </div>
      </div>
      <div class="right">
        <RxkButton @click="close">取消</RxkButton>
        <RxkButton type="primary" @click="confirm">确定</RxkButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, unref } from 'vue'
import type { RxkButton } from '@/components/common/RxkButton'
import Organizational from './components/organizationalPanel.vue'
import Members from './components/membersPanel.vue'
import DynamicParametersVue from './components/dynamicParameters.vue'
import Role from './components/rolePanel.vue'
import type { BasicProps, ComponentData, UserVOList, DynamicParameters } from './type'
import type { PanelActionType } from './hooks/usePanel'
import { isArray, isFunc } from '@/utils/is'
import { cloneDeep, recursion } from '@/utils/tools'

const emit = defineEmits(['close', 'confirm', 'registerPanel', 'update'])
const saveDefult = ref<boolean>(false) // 保存默认值
const organizationalRef = ref()
const isShowResigned = ref(false)
const roleRef = ref()
const membersRef = ref()
const loading = ref<boolean>(false)

const activeName = ref('members')
const isIncludeChild = ref<boolean>(false) // 父部门不包含子部门员工
const configuration = ref<boolean>(false) // 是否展示动态参数配置
const isRoleVisible = ref<boolean>(true) // 是否展示角色参数配置 赵美凤要求的
const showDefault = ref<boolean>(false) // 是否展示保存默认值
const allChecked = ref<boolean>(false) // 选中所有可见选项
const componentData = ref<ComponentData>({})
const checkedUser = ref<UserVOList[]>([])
const cloneCheckedUser = ref<UserVOList[]>([])
const dynamicParameters = ref<DynamicParameters>({
  acquireCurrent: 0,
  acquireCurrentFather: 0
})
const orginComponentData = ref<ComponentData>({})
const disabledIds = ref<string[]>([])
const showValueData = ref<string[]>([])
const isLoad = ref<boolean>(false)

async function reload(props: BasicProps, fn?: Fn) {
  console.log('orginPropsDataReload', cloneCheckedUser.value)
  console.log(JSON.stringify(orginComponentData.value) === JSON.stringify(props.data))
  const data = cloneDeep(cloneCheckedUser.value)
  handleChange(activeName.value)
  updateValue(data)
  fn && fn()
}
const $attrs = useAttrs()
async function init(propsValue: BasicProps, fn?: Fn) {
  console.log(propsValue, '多选init', isInit.value)
  if (!isInit.value && $attrs.isWorkbench) return
  activeName.value = propsValue.activeName || 'members'
  isIncludeChild.value = propsValue.isIncludeChild || false
  configuration.value = propsValue.configuration || false
  isRoleVisible.value = propsValue.isRoleVisible ?? true
  showDefault.value = propsValue.showDefault || false
  allChecked.value = propsValue.selectedShow || false
  saveDefult.value = propsValue.saveDefult || false
  disabledIds.value = propsValue.disabledIds || []
  showValueData.value = propsValue.showValueData?.map(item => item.id) || []
  dynamicParameters.value = propsValue.dynamicParameters || {
    acquireCurrent: 0,
    acquireCurrentFather: 0
  }

  //   // 获取数据
  const { data, api, menuId } = propsValue
  if (!api && data) {
    orginComponentData.value = { ...data }
    componentData.value = { ...data }
    // 处理部门人数数据
    handleDepartData()
    await handleCheckedValue(propsValue.showValueData || [])
    return false
  }
  if (!api || !isFunc(api)) return
  try {
    console.log(menuId, 'menuIdmenuId')
    loading.value = true
    const res = await api(
      {
        checkChildFlag: true,
        ...propsValue.paramsData,
        disableUserIds:
          (propsValue.showValueData && propsValue.showValueData?.map(item => item.id)) || []
      },
      menuId ? { MenuId: menuId } : ''
    )
    if (isArray(res)) {
      componentData.value = cloneDeep(res[0] || {})
      orginComponentData.value = cloneDeep(res[0] || {})
    } else {
      componentData.value = cloneDeep(res)
      orginComponentData.value = cloneDeep(res)
    }
    await handleDepartData()
    await handleCheckedValue(propsValue.showValueData || [])
    loading.value = false
    fn && fn()
  } catch (err) {
    console.log(err)
    loading.value = false
  }
}

// 处理回显值
async function handleCheckedValue(showValueData: UserVOList[]) {
  console.log('处理回显值', showValueData)

  // const idSet = new Set(showValueData.map(item => item.id))

  // const arr: UserVOList[] = []
  // const originLists = [orginComponentData.value?.showUserList, orginComponentData.value?.userVOList].filter(Boolean)
  // for (const list of originLists) {
  //   for (const user of list) {
  //     if (idSet.has(user.id)) {
  //       arr.push(user)
  //     }
  //   }
  // }
  let arr: UserVOList[] = []
  if (showValueData && showValueData.length > 0) {
    const ids = new Set(showValueData.map(item => item.id))
    const mergedUsers = [
      ...(orginComponentData.value?.showUserList || []),
      ...(orginComponentData.value?.userVOList || []),
      ...(orginComponentData.value?.userResignVOList || [])
    ]
    const userMap = new Map<string, UserVOList>()
    mergedUsers.forEach(user => {
      if (!userMap.has(user.id)) {
        userMap.set(user.id, user)
        if (ids.has(user.id)) {
          arr.push(user)
        }
      }
    })
  }
  console.log(arr, '最终回显值')
  cloneCheckedUser.value = arr
  updateValue(arr)
  emit('update', arr)
}

// 是否展示离职员工按钮状态变化时，从数据源头控制数据
const refreshKey = ref(0)
watch(
  () => isShowResigned.value,
  () => {
    refreshKey.value = Math.random()
    handleDepartData()
    nextTick(() => handleChange(activeName.value))
  }
)

// 当前组件初始化过滤数据
function filterDataFunc(data: UserVOList[]) {
  return data?.filter(item => (isShowResigned.value ? true : item.job !== 2)) || []
}

// 处理部门人数数据
async function handleDepartData() {
  // 根据是否显示离职员工，提前处理“组织架构”Tab的数据
  const data = cloneDeep(orginComponentData.value.deComponentTreeVO)
  recursion(data, item => {
    item.indeterminate = false
    item.checked = false
    const len = []
    if (isIncludeChild.value) {
      item.len = item.userVOList.length
    } else {
      recursion(item.children, children => {
        item.userVOList.push(...filterDataFunc(children.userVOList))
      })
      item.len = len.length + item.userVOList.length
    }
  })

  // 递归处理离职数据
  const recursionFilterFunc = (dataArr: UserVOList) => {
    return (
      dataArr?.map((item: UserVOList) => {
        const userVOList = filterDataFunc(item.userVOList)
        return {
          ...item,
          len: userVOList.length,
          userVOList: userVOList,
          children: item.children ? recursionFilterFunc(item.children) : undefined
        }
      }) || []
    )
  }

  componentData.value.deComponentTreeVO = recursionFilterFunc(cloneDeep(data))

  // 根据是否显示离职员工，提前处理“角色”Tab的数据
  const roleVOList = cloneDeep(orginComponentData.value.roleVOList)
  componentData.value.roleVOList =
    roleVOList?.map((item: { userVOList: UserVOList[] }) => ({
      ...item,
      userVOList: filterDataFunc(item.userVOList)
    })) || []

  // 根据是否显示离职员工，提前处理“成员”Tab的数据
  const userVOList = cloneDeep(orginComponentData.value.userVOList)
  componentData.value.userVOList = filterDataFunc(userVOList)
}

const panelActionType: PanelActionType = {
  init,
  getCheckedUser,
  updateValue,
  getSelectedShow,
  getContainChildren,
  getSaveDefault,
  getParameter,
  reload,
  handleCheckedValue,
  getIsLoad,
  updadeIsLoad
}
emit('registerPanel', panelActionType)

function close() {
  emit('close')
  const clone = cloneDeep(cloneCheckedUser.value)
  organizationalRef.value.clear()
  unref(isRoleVisible) && roleRef.value.clear()
  emit('update', clone)
}

watch(isIncludeChild, async val => {
  await handleDepartData()
  organizationalRef.value.handleIncludeChild(val)
})

watch(allChecked, val => {
  organizationalRef.value.handleAllCheck(val)
})

function confirm() {
  cloneCheckedUser.value = cloneDeep(checkedUser.value)
  organizationalRef.value.clear()
  unref(isRoleVisible) && roleRef.value.clear()
  emit('confirm')
}
/**
 * 非初始化判断
 * 判断是否改变
 */
const isInit = ref(true)
function updateValue(data: UserVOList[], type?: string) {
  isInit.value = false
  checkedUser.value = data
  if (type && type === 'clear') {
    cloneCheckedUser.value = [...checkedUser.value]
  }
}
function getSelectedShow() {
  return unref(allChecked.value)
}
function getContainChildren() {
  return unref(isIncludeChild.value)
}
function getSaveDefault() {
  return unref(saveDefult.value)
}
function getCheckedUser() {
  return unref(checkedUser.value)
}
function updateParameter(params: DynamicParameters) {
  dynamicParameters.value = params
}
function getParameter() {
  return unref(dynamicParameters.value)
}
function getIsLoad() {
  return isLoad.value
}
function updadeIsLoad(value: boolean) {
  console.log('多选面板加载中', value)
  isLoad.value = value
}
function handleChange(activeName: string) {
  checkedUser.value = filterDataFunc(checkedUser.value)

  switch (activeName) {
    case 'organizational':
      organizationalRef.value?.updateCheck(checkedUser.value)
      break
    case 'role':
      roleRef.value?.updateCheck(checkedUser.value)
      break
    case 'members':
      membersRef.value?.updateCheck(checkedUser.value)
      break
  }
}
</script>

<style lang="scss" scoped>
.personnelSelectionPanel {
  max-height: 55vh;
  overflow-y: hidden;
  .top {
    @include flex-center(row, space-between, center);
    padding: 17px 24px;
    border-bottom: 1px solid #ebeef5;
    .title {
      font-weight: 700;
      color: $gray;
      font-size: $saas-font-size-small;
    }
    .icon-close {
      cursor: pointer;
    }
  }
  .content {
    max-height: calc(50vh - 120px);
    height: 400px;
    overflow-y: auto;
    // @include flex-center(row, normal, normal);
    border-bottom: 1px solid #ebeef5;
    padding: 0 16px;
    .personnelSelectionPanelTabs {
      width: 100%;
      height: 100%;
      --el-tabs-header-height: 48px !important;
      :deep(.el-tabs__header) {
        margin: 0;
      }
      :deep(.el-tabs__content) {
        height: calc(100% - 48px);
      }
      :deep(.el-tabs__nav) {
        transform: translateX(16px) !important;
      }
      :deep(.el-tab-pane) {
        height: 100%;
      }
      :deep(.el-tabs__active-bar) {
        background-color: $primary-color;
      }
      :deep(.el-tabs__item.is-active) {
        color: $primary-color;
        font-weight: 700;
      }
      :deep(.el-tabs__item) {
        color: $secondary-text-color;
      }
      :deep(.el-tabs__nav-wrap::after) {
        height: 1px;
        background-color: #ebeef5;
      }
    }
    .left {
      width: 250px;
      border-right: 1px solid #ebeef5;
      overflow-y: auto;
    }
  }
  .bottom {
    padding: 16px 24px;
    @include flex-center(row, space-between, center);
    .left {
      :deep(.el-checkbox) {
        margin-right: 16px;
      }
    }
  }
}
</style>
